import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useAuthContext } from '../../contexts/AuthContext';
import { useUser } from '../../hooks/useUser';

interface AdminGuardProps {
  children: React.ReactNode;
}

const AdminGuard: React.FC<AdminGuardProps> = ({ children }) => {
  const { user, status } = useAuthContext();
  const { userDoc, loading } = useUser(user);

  // Afficher un indicateur de chargement pendant la vérification
  if (status === 'loading' || loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Rediriger si l'utilisateur n'est pas connecté
  if (status === 'unauthenticated') {
    return <Navigate to="/login" />;
  }

  // Vérifier si l'utilisateur est un administrateur
  if (userDoc?.role !== 'admin') {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h5" color="error" gutterBottom>
          Accès refusé
        </Typography>
        <Typography variant="body1">
          Vous n'avez pas les permissions nécessaires pour accéder à cette page.
        </Typography>
      </Box>
    );
  }

  // Si l'utilisateur est un administrateur, afficher le contenu
  return <>{children}</>;
};

export default AdminGuard;
